import React from 'react';

import * as styles from './index.module.scss';

const SimpleBanner = ({ backgroundImage, children, title, ctaLink, slim = false }) => (
    <section className={`${styles.simpleBanner} ${slim ? styles.slimBanner : ""} ${styles.bannerPadding}`}>
        {title && typeof title !== 'undefined' && title.length > 0 && (
            <h3 className={styles.simpleBannerTitle}>{title}</h3>
        )}
        {ctaLink ? (
            <a href={ctaLink} className={styles.simpleBannerLink}>
                {slim ? (
                    <img src={backgroundImage} className={styles.simpleBannerImg} alt={title}/>
                ) : (
                    <div 
                        className={styles.simpleBannerWrapper}
                        style={{
                            backgroundImage: `url(${backgroundImage})`
                        }}
                    >
                        {children && children}
                    </div>
                )}
            </a>
        ) : (
            slim ? (
                <img src={backgroundImage} className={styles.simpleBannerImg} alt={title}/>
            ) : (
                <div 
                    className={styles.simpleBannerWrapper}
                    style={{
                        backgroundImage: `url(${backgroundImage})`
                    }}
                >
                    {children && children}
                </div>
            )
        )}
    </section>
);

export default SimpleBanner;